import { render } from "./DeviceModal.vue?vue&type=template&id=52a12629"
import script from "./DeviceModal.vue?vue&type=script&lang=js"
export * from "./DeviceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__